import React from 'react';
import { isDefined } from '../util/Common';
import { Message } from 'semantic-ui-react';

export const ErrorMessage = (props) => (
    isDefined(props.text) && props.text !== '' ? (
        <Message error icon='warning circle' content={ props.text }/>
    ) : (
        null
    )
)


// WEBPACK FOOTER //
// ./src/components/Message.js